/**
 * Server-anchored time
 *
 * FR-015 forbids conflict resolution from trusting the device clock. A phone
 * with a wrong clock must not be able to overwrite a newer change made
 * elsewhere, so local writes are stamped with the server's notion of now:
 * device time plus the offset measured against the server's `Date` header on
 * the last sync.
 *
 * The offset is persisted (see `meta.clockSkewMs`) so the correction survives
 * a restart and still applies to writes made entirely offline.
 */

let skewMs = 0;

/** Restore a persisted offset at startup. */
export const hydrateSkew = (ms) => {
  skewMs = Number.isFinite(ms) ? ms : 0;
};

export const getSkewMs = () => skewMs;

/**
 * Measure the offset from a server-supplied time.
 * @param {string} serverDate - an HTTP `Date` header or ISO-8601 timestamp
 * @returns {number|null} the new offset in ms, or null if unparseable
 */
export const recordSkew = (serverDate) => {
  const server = Date.parse(serverDate);
  if (Number.isNaN(server)) return null;
  skewMs = server - Date.now();
  return skewMs;
};

/** Server-anchored `now`, as the UTC ISO-8601 string the sync queue compares. */
export const nowIso = () => new Date(Date.now() + skewMs).toISOString();
